import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const SwitchOption = ({ values }) => (
  <Content>
    {({
      switchBusinessSwitchOptionLabel,
      switchBusinessSwitchOptionValidationMessage,
      switchBusinessSwitchOptionValue1 = '',
      switchBusinessSwitchOptionValue2 = '',
      switchYourAccountText = ''
    }) => (
      <Field
        name="switchOption"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="switchOption"
            title={switchBusinessSwitchOptionLabel}
            description={switchYourAccountText}
            validationMessage={
              touched && !!error ? switchBusinessSwitchOptionValidationMessage : ''
            }
          >
            <GenericRadio.InlineSet
              groupName="switchOption"
              items={[
                {
                  id: switchBusinessSwitchOptionValue1,
                  labelText: switchBusinessSwitchOptionValue1
                },
                {
                  id: switchBusinessSwitchOptionValue2,
                  labelText: switchBusinessSwitchOptionValue2
                }
              ]}
              {...input}
              selectedId={values.switchOption}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default SwitchOption;
